// extracted by mini-css-extract-plugin
export var leftAlign = "_1w-2";
export var popper = "_1w-0";
export var subtitle = "_1w-1";